import { ReactNode } from 'react';
import { Card as BaseCard, styled } from '@mui/material';
import { Card as CardSchema } from '@/schemas/sceneDataSchema';
import { CardBorderColor } from '@/constants/cardTypes';

interface CardProps {
  id?: string | null | undefined;
  children: ReactNode;
  component: CardSchema;
}

export function Card({ id, component, children }: CardProps) {
  return (
    <StyledCard
      id={id ?? undefined}
      border={component.border}
      borderRadius={component.border_radius}
      borderColor={component.border_color ?? undefined}
      shadow={component.shadow}
    >
      {children}
    </StyledCard>
  );
}

interface StyledCardProps {
  border: boolean;
  borderRadius: string;
  borderColor?: CardBorderColor;
  shadow: string;
}

const StyledCard = styled(BaseCard, {
  shouldForwardProp: (prop) =>
    prop !== 'borderRadius' && prop !== 'borderColor' && prop !== 'shadow' && prop !== 'border',
})<StyledCardProps>`
  border: ${({ border, borderColor }) => {
    if (!border) return 'none';
    if (!borderColor || borderColor === CardBorderColor.BORDER) {
      return '1px solid var(--mui-palette-border-secondary)';
    }
    return `1px solid var(--mui-palette-${borderColor}-main)`;
  }};
  border-radius: ${({ borderRadius }) => {
    switch (borderRadius) {
      case 'small':
        return 'var(--border-radius-small)';
      case 'medium':
        return 'var(--border-radius-medium)';
      case 'large':
        return 'var(--border-radius-large)';
      default:
        return 'var(--border-radius-large)';
    }
  }};
  box-shadow: ${({ shadow }) => {
    switch (shadow) {
      case 'none':
        return 'var(--shadow-none)';
      case 'small':
        return 'var(--shadow-small)';
      case 'large':
        return 'var(--shadow-large)';
      default:
        return 'var(--shadow-none)';
    }
  }};
`;
